import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DELETEPACKAGE = gql`
  mutation removePackage($id: ID!) {
    removePackage(id: $id)
  }
`;

function DeletePackage({ id, name, children, onDeletePackage }) {
  const [runDeletePackage, deletePackage] = useMutation(DELETEPACKAGE, {
    onCompleted({ removePackage }) {
      if (removePackage) {
        message.success(`پکیج ${name ? name : ""} حذف شد.`);
        onDeletePackage();
      } 
    },
    onError(err) {
      message.error(err.message);
    },
  });

  const doDeletePackage = () => {
    runDeletePackage({
      variables: { id },
    });
  };
  return (
    <>
      <Popconfirm
        title={`حذف ${name ? `پکیج ${name}` : "پکیج"}?`}
        okText="حذف"
        cancelText="خیر"
        onConfirm={doDeletePackage}
      >
        <span>{children}</span>
      </Popconfirm>
    </>
  );
}

export default DeletePackage;
